import { DualPosition } from "appworks/graphics/pixi/dual-position";
import { Text } from "appworks/graphics/pixi/text";
import { Services } from "appworks/services/services";
import { deepClone } from "appworks/utils/collection-utils";
import { gameLayers } from "game-layers";
import { SymbolComponent } from "slotworks/components/matrix/symbol/symbol-component";

const TierMultiplierMap = new Map([
    ["GRAND", 1000], // GRAND
    ["MAJOR", 200],  // MAJOR
    ["MINOR", 100],  // MINOR
    ["MINI", 50]     // MINI
]);

export class TGRSymbolComponent extends SymbolComponent {

    protected quickhitText: Text;
    protected lastValue: number;

    protected updateStatic(transform: DualPosition) {
        const symbolId: string = this.symbolId;

        let value: number;
        if (/^QH_.*/.test(this.symbolId)) {
            const mStr: string = this.symbolId.replace(/^QH_/, "");
            const multiplier: number = parseInt(mStr);
            value = multiplier * Services.bet.getTotalStake();
            this.symbolId = "QH";
        } else if (/^QH\+.*/.test(this.symbolId)) {
            const tStr: string = this.symbolId.replace(/^QH\+/, "");
            const multiplier: number = TierMultiplierMap.get(tStr);
            value = multiplier * Services.bet.getTotalStake();
        }

        if (this.quickhitText && this.lastValue !== value) {
            if (this.quickhitText.parent) {
                this.quickhitText.parent.removeChild(this.quickhitText);
            }
            this.lastValue = value;
            this.quickhitText.destroy();
            this.quickhitText = null;
        }

        super.updateStatic(transform);
        this.symbolId = symbolId;

        if (!this.quickhitText && value) {
            const templateText: Text = gameLayers.Templates.elements.default.quickhit_text;

            this.quickhitText = new Text("", deepClone(templateText.style));
            this.staticSprite.addChild(this.quickhitText);

            this.quickhitText.text = Services.currency.format(value, false).replace(" ", "");

            this.quickhitText.pivot = templateText.pivot.clone();
            this.quickhitText.anchor = templateText.anchor.clone();
            this.quickhitText.landscape = templateText.landscape.clone();

            this.quickhitText.landscape.x = this.quickhitText.landscape.width * -0.5;
            this.quickhitText.landscape.y = this.quickhitText.landscape.height * -0.5;

            this.quickhitText.updateTransform();
        }
    }
}
